import { Link } from "react-router-dom"
import Logo from "../components/Logo"
import Card from "../components/Card"
import Visible from "../components/Svg/Visible"
import NotVisible from "../components/Svg/NotVisible"
import Button from "../components/Button"
import useForm from "../useForm"
import usePassword from "../usePassword"
// import { useNavigate } from "react-router-dom";

function Login() {
     const {handleChange, handleSubmit, values, errors, message, errmsg} = useForm({
         email: '',
         password: ''
     });
     const {showPassword,handleShowPassword,  handleHidePassword} = usePassword();
    //  const navigate = useNavigate();

          

  return (
    <div className='login-container'>
        <Logo />
        <Card>
        {message ? <p className="text-success my-3">{message}</p> : 
    <p className="text-danger my-3">{errmsg}</p>}
           <h4 className="card-head">
               Login to your account
          </h4>
           <p className="card-text"> 
               Enter your email and password to continue
           </p>
           <form onSubmit={handleSubmit}>
              <input
               className={errors.email ? "error login-input gen-input" : "login-input gen-input"}
               type="email" 
               placeholder='Email'
               id="login-email"
               name="email"
               onChange={handleChange}
               value={values.email}
               />
              {errors.email && <p className="small">{errors.email}</p>}
              <div className="password-input-group">
                  <input 
                  className={errors.password ? "error signup-input gen-input" : "signup-input gen-input"}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  id="login-password"
                  name="password"
                  value={values.password}
                  onChange={handleChange} />
                     {showPassword ?
                <div className="gs-not-visible-group" onClick={handleHidePassword}>
                <NotVisible stroke="#7A8996"/>
              </div> : 
              <div className="gs-visible-group" onClick={handleShowPassword}>
              <Visible fill="#7A8996" />
            </div>}
              </div>
              {errors.password && <p className="small">{errors.password}</p>}
              <Button disabled={errors.password || errors.email } type='submit'>
                  Sign in
              </Button>

           </form>

            <Link to='/forgotpassword' className="link-text">
                Forgot Password
            </Link>

            <div className="no-account">
                <p>Don't have an account?</p>
                <Link to='/signup' className="link-text sign-up-link">
                    Sign Up
                </Link>
            </div>
        </Card> 
    </div>
  )
}

export default Login